import React from 'react'
import RequestBuilder from './RequestBuilder';
import conf from 'configuration.json'

export default class BaseComponent extends React.Component {

    /**
     * Handles change events of component state.
     *
     * @param name parameter name in the component state.
     * @param value new value to set OR event to handle.
     */
    handleChange = (name) => (value) => {
        if (value.target) {
            value = value.target.type === 'checkbox' ? value.target.checked : value.target.value;
        }
        this.setState({[name]: value});
    };

    /**
     * Handles change events of nested component in the state.
     *
     * @param name parameter name in the component state.
     * @param nestedName nested name of the parameter in the component state or object with multiple parameters.
     * @param value new value to set OR event to handle (may be omitted if nestedName is an object with multiple parameters).
     */
    handleNestedChange = (name, nestedName) => (value) => {
        if (value.target) {
            value = {[nestedName]: value.target.type === 'checkbox' ? value.target.checked : value.target.value};
        }

        this.setState({
            [name]: Object.assign({}, this.state[name], value)
        });
    };

    /**
     * Closes the browser window. It is a hack and works only in Internet Explorer, but business guys want this feature.
     */
    closeWindow = () => {
        window.open("javascript:window.open('', '_self', ''); window.close();", "_self");
    };

    /**
     * Uploads the list of attachments by converting them to Uint8Array representation (it is mandatory to work in IE),
     * appending the result to the specified formData and invoking the specified callback.
     * @param attachments array of attachments.
     * @param formData instance of FormData.
     * @param formDataKey key that will be used to append attachments to formData.
     * @param callback callback that has to be executed when all the files will be converted and appended to formData.
     */
    uploadAttachments = (attachments, formData, formDataKey, callback) => {
        let filesCount = attachments.length;
        if (filesCount === 0) {
            callback(formData);
        } else {
            let iterator = 0;
            let data = [];
            let convertedAttachments = [];

            attachments.forEach((element) => {
                let reader = new FileReader();
                reader.onloadend = (evt) => {
                    if (evt.target.readyState === FileReader.DONE) {
                        data = Array.prototype.slice.call(new Uint8Array(evt.target.result));
                        convertedAttachments[iterator] = {
                            file : data,
                            displayableName : element.name
                        };
                        iterator++;
                        if(iterator === filesCount) {
                            let attachmentsJson = JSON.stringify({
                                attachments: convertedAttachments
                            });
                            formData.append(formDataKey, new Blob([attachmentsJson], {type: "application/json"}));
                            callback(formData);
                        }
                    }
                };
                reader.readAsArrayBuffer(element);
            });
        }
    };

    /**
     * Function to decode base64-encoded string to byte array.
     */
    strToByteArray = (string) => {
        let byteCharacters = atob(string);
        let array = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            array[i] = byteCharacters.charCodeAt(i);
        }
        return array;
    };

    /**
     * Log outs user from VPQuick application and navigates his to the specified url.
     * @param navigationUrl url to be navigated after logging out.
     */
    logout = (navigationUrl) => {
        this.request('post', conf.rest.logoutEndpoint).send(() => {
            window.location.href = navigationUrl;
        });
        sessionStorage.clear();
    };

    /**
     * Opens EditComplaint dialog in the new window.
     * @param complaint complaint complaint to be opened.
     * @param parameters optional array of the strings that should be passed to EditComplaint as the request parameters.
     */
    openComplaint = (complaint, parameters) => () => {
        let params = "";
        if (parameters) {
            parameters.forEach(p => params += ";" + p);
        }
        window.open('/edit/' + btoa(complaint.complaintNumber + ';' + complaint.basket + params), '_blank');
    };

    /**
     * Navigates user to error page.
     */
    navigateToErrorPage = () => {
        window.location.href = '/errorPage';
    };

    /**
     * Returns cookie value by its name.
     * @param name cookie name.
     */
    getCookie = (name) => {
        const pair = document.cookie.split('; ').find(x => x.startsWith(name + '='));
        if (pair) {
            return pair.split('=')[1];
        }
    };

    /**
     * Creates a new instance of {@link RequestBuilder}.
     * @param method HTTP method, e.g. 'post'.
     * @param endpoint HTTP endpoint.
     * @return a filled instance of request builder.
     */
    request(method, endpoint) {
        return new RequestBuilder(method, endpoint, this.state ? this.state.tvppLogoutUrl : undefined, this.navigateToErrorPage);
    }

    /**
     * The method is created for convenience and can be (re)moved in future.
     * @param browserName a short name of browser to do the check.
     * @return a boolean values whether the client browser corresponds to the given name.
     */
    browserIs(browserName) {
        if ("IE11" == browserName) {
            return !!window.MSInputMethodContext && !!document.documentMode;
        } else {
            return false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/common/BaseComponent.js